import React, { useState } from 'react';
import Text from '../../../../../../Components/Base/Text/Text';
// @ts-ignore
import styles from './BankAccountSetup.module.scss';
import { useAppContext } from '../../../../../../Services/AppContext';
import BankAccountSetupDefaultForm from './BankAccountSetupDefaultForm';
import BankAccountSetupLatamForm from './BankAccountSetupLatamForm';
import BankAccountSetupMexicoForm from './BankAccountSetupMexicoForm';
import { useEffectAsync } from '../../../../../../helpers';
import apiClient from '../../../../../../Services/ApiClient';
import Loading from '../../../../../../Components/Loading';
import { removeNullFromObject } from '../../../../../Base/Helpers/object.helper';
import useApiClient from '../../../../../Base/Hooks/useApiClient';
import useNotification from '../../../../../../Hooks/useNotification.hook';
import useTranslation from '../../../../../../Hooks/useTranslation';

interface Props {
	rootWorkplaceId: string;
}

export interface BankAccount {
	prefix?: string;
	number?: string;
	suffix?: string;
	name?: string;
	type?: string;
	clabe?: string;
	cci?: string;
}

const BankAccountSetup: React.FC<Props> = ({ rootWorkplaceId }) => {
	const { globalTemplate } = useAppContext();
	const [isLoading, setIsLoading] = useState(false);
	const [defaultValues, setDefaultValues] = useState<object>({});
	const { displayError } = useApiClient();
	const { showNotificationSuccess } = useNotification();
	const { t } = useTranslation();

	useEffectAsync(async () => {
		setIsLoading(true);
		const { data } = await apiClient.get(
			`/workplaces/${rootWorkplaceId}/bank-account`,
		);
		if (data) {
			setDefaultValues(removeNullFromObject(data));
		}
		setIsLoading(false);
	}, []);

	const handleSave = async (values: BankAccount) => {
		try {
			const response = await apiClient.patch(`/workplaces/${rootWorkplaceId}`, {
				bankAccount: values,
			});
			if (response.status === 200) {
				showNotificationSuccess({
					content: t('base.saved'),
				});
			}
		} catch (e) {
			displayError(e);
		}
	};

	let component;

	switch (globalTemplate) {
		case 'peru':
		case 'ecuador':
		case 'colombia':
			component = (
				<BankAccountSetupLatamForm
					defaultValues={defaultValues}
					onSuccess={handleSave}
				/>
			);
			break;
		case 'mexico':
			component = (
				<BankAccountSetupMexicoForm
					defaultValues={defaultValues}
					onSuccess={handleSave}
				/>
			);
			break;
		case 'slovakia':
		case 'czechia':
		default:
			component = (
				<BankAccountSetupDefaultForm
					defaultValues={defaultValues}
					onSuccess={handleSave}
				/>
			);
			break;
	}

	if (isLoading) {
		return <Loading />;
	}

	return (
		<div className={styles.wrapper}>
			<Text tx='registration.account.description1' className={styles.title} />
			<div className={styles.formWrapper}>
				<div className='row'>
					<div className='col-xl-8 col-lg-12 col-12'>{component}</div>
				</div>
			</div>
		</div>
	);
};

export default BankAccountSetup;
